import type { Environment } from '@hangar/shared';
import { cn } from '@/lib/utils';
import { Icon } from '@/components/Icon';
import { StatusPill, Tag } from '@/components/badges';

export function ProtectionChip({ env, plain }: { env: Environment; plain?: boolean }) {
  if (!env.isProtected) return <span className={cn('text-[13px] text-subtle', !plain && 'text-xs')}>Unprotected</span>;
  return (
    <span className={cn('inline-flex items-center gap-1 text-foreground', plain ? 'text-[13px]' : 'text-xs')}>
      <Icon name="lock" size={plain ? 16 : 14} className="text-muted-foreground" />
      Protected
    </span>
  );
}

export function Patterns({ env }: { env: Environment }) {
  if (env.allowedBranchPatterns.length === 0) {
    return (
      <span className="inline-flex items-center gap-1.5 text-xs text-subtle">
        <Tag className="text-foreground">*</Tag>
        any branch
      </span>
    );
  }
  return (
    <span className="flex flex-wrap gap-1">
      {env.allowedBranchPatterns.map((p) => (
        <Tag key={p} className="max-w-full text-foreground">
          <span className="truncate">{p}</span>
        </Tag>
      ))}
    </span>
  );
}

export function Forks({ env }: { env: Environment }) {
  return env.untrustedRefsBlocked ? <StatusPill status="failed" label="Blocked" /> : <StatusPill status="succeeded" label="Allowed" />;
}
